<template>
	<div>
		<CModal
			:show.sync="isShow"
			:close-on-backdrop="false"
			centered
			size="lg"
		>
			<template #header-wrapper>
				<ModalHeaderWrapper :title="title" @onClose="close" />
			</template>
			<template #default>
				<CRow>
					<CCol>
						<FormGetPhoneNumber
							ref="form-phone-number"
							:rule="localRule"
							:phone-number-list="localPhoneNumberList"
							@onGetPhoneNumber="handleGet"
						>
							<template #no-item>
								<div class="no-item d-flex text-center" data-test-id="no-item">
									<div class="d-block">
										<div
											class="font-weight-bolder color-black-45"
										>
											No phone number yet
										</div>
										<div class="typo-body-2 color-black-45">
											Add "phone number" in order to set condition.
										</div>
									</div>
								</div>
							</template>
						</FormGetPhoneNumber>
					</CCol>
				</CRow>
			</template>
			<template #footer>
				<BaseModalFooter
					:total-select="localPhoneNumberList.length"
					:is-show-clear="true"
					:disabled-confirm="!isListChanged"
					@onCancel="handleCancel"
					@onClear="handleClear"
					@onConfirm="handleSubmit"
				/>
			</template>
		</CModal>
	</div>
</template>

<script>
import ModalHeaderWrapper from '@/components/ModalHeaderWrapper.vue';
import FormGetPhoneNumber from '@/components/FormGetPhoneNumber.vue';
import BaseModalFooter from '@/components/BaseModalFooter.vue';

export default {
	name: 'ModalPhoneNumber',
	components: {
		ModalHeaderWrapper,
		FormGetPhoneNumber,
		BaseModalFooter,
	},
	props: {
		title: {
			type: String,
			default: 'Add Phone Number',
		},
		titleConfirm: {
			type: String,
			default: null,
		},
		descriptionConfirm: {
			type: String,
			default: null,
		},
		rule: {
			type: String,
			default: null,
		},
		phoneNumberList: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			isShow: false,
			isListChanged: false,
			localPhoneNumberList: [],
			localRule: '',
		};
	},
	methods: {
		async resetState() {
			this.localRule = this.rule;
			this.localPhoneNumberList = [...this.phoneNumberList];
			this.isListChanged = false;
			await this.$nextTick();
			this.$refs['form-phone-number'].resetState();
		},
		open() {
			this.isShow = true;
			this.resetState();
		},
		close() {
			this.isShow = false;
		},
		submit() {
			this.isShow = false;
			this.$emit('onConfirm', { rule: this.localRule, list: this.localPhoneNumberList });
		},
		handleGet({ rule, list }) {
			this.localRule = rule;
			this.localPhoneNumberList = list;
			this.isListChanged = true;
		},
		handleCancel() {
			this.close();
		},
		async handleClear() {
			this.localRule = '';
			this.localPhoneNumberList = [];
			this.isListChanged = true;
			await this.$nextTick();
			this.$refs['form-phone-number'].resetState();
		},
		handleSubmit() {
			this.submit();
		},
	},
};
</script>

<style lang="scss" scoped>
	.no-item {
		min-height: rem(200);
		justify-content: center;
		align-items: center;
	}

	::v-deep .list-item {
		min-height: rem(200);
		padding: 0;
		margin: 0;
	}
</style>
